/* eslint-disable eag/match-named-export */
import {ContractInformationResponseBodyV2} from '@dms/api/customer';
import i18n from '@dms/i18n';
import {getNaturalPersonFullName} from '@dms/shared';

import {LegalFormEnum} from '../types/LegalFormEnum';

const isNaturalPerson = (contractInformation?: ContractInformationResponseBodyV2) =>
  contractInformation?.legalForm === LegalFormEnum.NATURAL_PERSON;

const isSelfEmployed = (contractInformation?: ContractInformationResponseBodyV2) =>
  contractInformation?.legalForm === LegalFormEnum.SELF_EMPLOYED;

export const getContractName = (contract?: ContractInformationResponseBodyV2) => {
  if (!contract) {
    return '';
  }

  if (isNaturalPerson(contract)) {
    return getNaturalPersonFullName(contract.person);
  }

  return contract.businessInfo?.businessInfo.tradeName || '';
};

export const getContractType = (contract?: ContractInformationResponseBodyV2) => {
  if (!contract) {
    return '';
  }

  if (isNaturalPerson(contract)) {
    return i18n.t('entity.person.labels.physicalPerson');
  } else if (isSelfEmployed(contract)) {
    return i18n.t('entity.customer.labels.isSelfEmployed');
  }

  return i18n.t('general.labels.company');
};
